import { InstallPage } from '../../shared/ui';
import { useAppContext } from '../../core';
import { OtherInstallCopy } from './components/OtherInstallCopy';
import styles from './PwaInstallOther.module.css';

export function PwaInstallOther() {
  const { origin, host } = useAppContext();

  return (
    <InstallPage className={styles.root}>
      <OtherInstallCopy host={host} origin={origin} />
    </InstallPage>
  );
}
